import { ComponentPropsWithoutRef, Fragment, forwardRef, useMemo } from 'react';

import { makeStyles } from '@material-ui/core';

import { diffChars } from 'diff';

import { Text } from '@backstage/ui';

const useStyles = makeStyles({
  addedText: {
    color: 'var(--bui-fg-success)',
  },
  removedText: {
    color: 'var(--bui-fg-secondary)',
    textDecoration: 'line-through',
  },
  modifiedText: {
    color: 'var(--bui-fg-primary)',
  },
});

export interface DeltaTextProps
  extends Omit<ComponentPropsWithoutRef<typeof Text>, 'children'> {
  oldText: string;
  newText: string;
  disableDiff?: boolean;
}

export const DeltaText = forwardRef<HTMLDivElement, DeltaTextProps>(
  ({ oldText, newText, disableDiff, ...props }, ref) => {
    const classes = useStyles();
    const diff = useMemo(() => diffChars(oldText, newText), [oldText, newText]);

    if (disableDiff) {
      return (
        <Text {...props} ref={ref}>
          <span className={classes.removedText}>{oldText}</span>{' '}
          <span className={classes.addedText}>{newText}</span>
        </Text>
      );
    }

    return (
      <Text {...props} ref={ref}>
        {diff.map((part, index) => (
          <Fragment key={index}>
            {part.added && (
              <span className={classes.addedText}>{part.value}</span>
            )}
            {part.removed && (
              <span className={classes.removedText}>{part.value}</span>
            )}
            {!part.added && !part.removed && <span>{part.value}</span>}
          </Fragment>
        ))}
      </Text>
    );
  },
);
